export default __webpack_public_path__ + "fd255270e6f89f8353f10b76992bc1a9.png";